// Our main CSS
import '../css/app.css'

//Our main JS
import './menu.js'
import './quantity.js'



/**
 * 🦄: Now do your magic.
 */

// layzyload and/or play/pause inline videos when they are in/out of view
const autoplaying_videos = document.querySelectorAll('video[playsinline]')

if (autoplaying_videos?.length) {
  ;(async () => {
    const { default: handleVideos } = await import('./modules/inline-videos')
    handleVideos(autoplaying_videos)
  })()
}

/**
 * ⛷️: Alpine.js
 */
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

/**
 * 🌈 Swiper.js
 */

import Swiper from 'swiper'
import { Autoplay, Scrollbar } from 'swiper/modules' // Add Scrollbar module
import 'swiper/css'
import 'swiper/css/scrollbar'
import 'swiper/css/autoplay'

/* eslint-disable  no-unused-vars */
const swiper = new Swiper('.products-container', {
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true
  },
  modules: [Autoplay, Scrollbar],
  slidesPerView: 1.2,
  autoplay: {
    delay: 2000
  },
  grabCursor: true,
  speed: 2000,
  loop: false,
  breakpoints: {
    640: {
      slidesPerView: 1.2,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 3.2,
      spaceBetween: 10
    },
    1400: {
      slidesPerView: 4.2,
      spaceBetween: 10
    }
  }
})
